// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-dropdown-items{
    padding-left: 0rem;
}
.p-datatable {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}
.p-datatable .p-datatable-header {
    background: linear-gradient(180deg, rgba(177, 188, 196, 0.4) 0%, rgb(237, 243, 245,0.9) 80%);
    color: #495057;
    border: 1px solid #e9ecef;
    border-width: 1px 0 1px 0;
    padding: 1rem 1rem;
    font-weight: 600;
    
}
.p-datatable .p-datatable-thead > tr > th{
     text-align: center; 
     padding: 1rem 1rem;
     border: 5px solid #e9ecef;
     border-width: 0 0 1px 0;
     font-weight: 600;
     color: #495057;
     background: linear-gradient(180deg, rgb(237, 243, 245) 100%,  rgb(240, 242, 243,0.8) 0%);
     transition: box-shadow 0.5s;
     font-size: 18px;
}
.p-datatable .p-datatable-tbody > tr > td{
    text-align: left;
    border: 1px solid #58595b45;
    border-width: 0 0 1px 0;
    padding: 1rem 1rem;
    background: linear-gradient(180deg,   rgba(251, 251, 252, 0.7) 100%,  rgba(251, 251, 252, 0.7)  0%);
}
.flex {
    display: flex !important;
}
.gap-2 {
    gap: .5rem !important;
}
.align-items-center {
    align-items: center !important;
}
.justify-content-between {
    justify-content: space-between !important;
}
.flex-wrap {
    flex-wrap: wrap !important;
}

.p-datatable .p-column-header-content{
    display: inline;
}
.p-component{
    font-feature-settings: var(--font-feature-settings, normal);
    font-size: 1rem; 
}`, "",{"version":3,"sources":["webpack://./src/Components/regulator/prime_edit.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,4FAA4F;IAC5F,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;;AAEpB;AACA;KACK,kBAAkB;KAClB,kBAAkB;KAClB,yBAAyB;KACzB,uBAAuB;KACvB,gBAAgB;KAChB,cAAc;KACd,wFAAwF;KACxF,2BAA2B;KAC3B,eAAe;AACpB;AACA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;IAClB,mGAAmG;AACvG;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;AACA;IACI,2DAA2D;IAC3D,eAAe;AACnB","sourcesContent":[".p-dropdown-items{\r\n    padding-left: 0rem;\r\n}\r\n.p-datatable {\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\r\n}\r\n.p-datatable .p-datatable-header {\r\n    background: linear-gradient(180deg, rgba(177, 188, 196, 0.4) 0%, rgb(237, 243, 245,0.9) 80%);\r\n    color: #495057;\r\n    border: 1px solid #e9ecef;\r\n    border-width: 1px 0 1px 0;\r\n    padding: 1rem 1rem;\r\n    font-weight: 600;\r\n    \r\n}\r\n.p-datatable .p-datatable-thead > tr > th{\r\n     text-align: center; \r\n     padding: 1rem 1rem;\r\n     border: 5px solid #e9ecef;\r\n     border-width: 0 0 1px 0;\r\n     font-weight: 600;\r\n     color: #495057;\r\n     background: linear-gradient(180deg, rgb(237, 243, 245) 100%,  rgb(240, 242, 243,0.8) 0%);\r\n     transition: box-shadow 0.5s;\r\n     font-size: 18px;\r\n}\r\n.p-datatable .p-datatable-tbody > tr > td{\r\n    text-align: left;\r\n    border: 1px solid #58595b45;\r\n    border-width: 0 0 1px 0;\r\n    padding: 1rem 1rem;\r\n    background: linear-gradient(180deg,   rgba(251, 251, 252, 0.7) 100%,  rgba(251, 251, 252, 0.7)  0%);\r\n}\r\n.flex {\r\n    display: flex !important;\r\n}\r\n.gap-2 {\r\n    gap: .5rem !important;\r\n}\r\n.align-items-center {\r\n    align-items: center !important;\r\n}\r\n.justify-content-between {\r\n    justify-content: space-between !important;\r\n}\r\n.flex-wrap {\r\n    flex-wrap: wrap !important;\r\n}\r\n\r\n.p-datatable .p-column-header-content{\r\n    display: inline;\r\n}\r\n.p-component{\r\n    font-feature-settings: var(--font-feature-settings, normal);\r\n    font-size: 1rem; \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
